export default {
  DASHBOARD_CMR_LIST: state => {
    return state.dashboardData
  },
  DASHBOARD_CMR_TOTAL: state => {
    return state.dashboardCmrTotals
  },
  CMR_LIST: state => {
    return state.cmrData
  },
  CMR_TOTAL: state => {
    return state.cmrTotals
  },
  PDF: state => {
    return state.pdf
  },
  /*PAGINATION: state => {
    return state.pagination
  }*/
  USERS_LIST: state => {
    return state.userData
  },
  USERS_TOTAL: state => {
    return state.userTotals
  },
  ROLES_LIST: state => {
    return state.roles
  },
  ROLES_TOTAL: state => {
    return state.rolesTotals
  },
  ORGANIZATIONS_LIST: state => {
    return state.organizations
  },
  ORGANIZATIONS_TOTAL: state => {
    return state.organizationsTotals
  },
  COUNTRIES_LIST: state => {
    return state.countries
  },
  LOGIN_USER: state => {
    return state.loginUser
  },
  LANG: state => {
    return state.language
  },
  GET_USER_ORGANIZATIONS: state => {
    return state.userOrganizations
  }
}